import ListingCard from "./ListingCard";
// import { useState } from "react";
import spinner from "../../assets/spinner2.svg"
import Skeleton from "react-loading-skeleton";
import ListingsSkeleton from "../ListingsSkeleton";
import { useRef, useEffect } from "react";
import { useListingsContext } from "../../context/ListingsContext";

const ListListings = ({listings, setListings, className, search, categoryFilter, locationFilter}) => {
    // const [loading, setLoading] = useState(false)

    // const getListings = async() => {
    //     try {
    //         // const response = await fetch("http://localhost:5000/listings")
    //         // const jsonData = await response.json()
    //         const querySnapshot = await getDocs(collection(db, "listings"))
    //         const queryRes = []
    //         querySnapshot.forEach((doc) => {
    //             const docData = doc.data()
    //             docData.listing_id = doc.id
    //             console.log(docData)
    //             queryRes.push(docData)
    //         })
    //         // setListings(queryRes)
    //         useListingsUpdate()
    //         console.log(queryRes)
    //     } catch(err) {
    //         console.error(err.message)
    //     }
    // }

    // useEffect(() => {
    //     getListings()
    // }, [])

    // const listings = useListingsContext().listings

    // const route = window.location.pathname
    // let listings = null
    // if (route == "/") {
    //     listings = useListingsContext().listings
    // } else if (route == "/myoffers") {
    //     listings = []
    // } else if (route == "/mylistings") {
    //     listings = []
    // }
    
    // const updateListings = useListingsContext().updateListings

    // const onDeleteClick = async (listing_id) => {
    //     try {
    //         await deleteDoc(doc(db, "listings", listing_id))
    //         // const response = await fetch(`http://localhost:5000/listings/${listing_id}`, {
    //         //     method: "DELETE",
    //         // })
            
    //         // console.log(response)
    //         // setListings(listings.filter(listing => listing.listing_id !== listing_id))
    //         const newListings = listings.filter((listing) => listing.listing_id != listing_id)
    //         console.log(newListings)
    //         updateListings(newListings)
    //         // setListings(newListings)
    //     } catch (err) {
    //         console.error(err.message)
    //     }
    // }
    const getListings = useListingsContext().getListings
    const hasMore = useListingsContext().hasMore
    const containerRef = useRef(null)

    useEffect(() => {
            const observer = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting && hasMore) {
                        console.log(entries)
                        if (search || categoryFilter || locationFilter) {
                            const zipFromLocationFilter = locationFilter.split(",")[0]
                            getListings(search, categoryFilter, zipFromLocationFilter)
                        } 
                        else {
                            getListings()
                        }
                    }
                },
                {
                    root: null, // Use the viewport as the root
                    threshold: 0, // Trigger when 80% of the element is visible
                }
            );
    
            if (containerRef.current) {
                observer.observe(containerRef.current);
            }
    
            return () => {
                if (containerRef.current) {
                    observer.unobserve(containerRef.current);
                }
            };
        }, [hasMore, getListings]);

    return (
    // <div className="list-listings">
    //     {/* <div className={className ? `${className} listings-grid` : "listings-grid"}> */}
    //         {
    //             // listings == null ? 
    //             // <div className={className ? `${className} listings-grid` : "listings-grid"}>
    //             //     <div className="skeleton-listing-card">
    //             //         <Skeleton className="thumbnail-image"/>
    //             //         <Skeleton count={3} width="50%"/>
    //             //     </div>
    //             //     <div className="skeleton-listing-card">
    //             //         <Skeleton className="thumbnail-image"/>
    //             //         <Skeleton count={3} width="50%"/>
    //             //     </div>
    //             //     <div className="skeleton-listing-card">
    //             //         <Skeleton className="thumbnail-image"/>
    //             //         <Skeleton count={3} width="50%"/>
    //             //     </div>
    //             //     <div className="skeleton-listing-card">
    //             //         <Skeleton className="thumbnail-image"/>
    //             //         <Skeleton count={3} width="50%"/>
    //             //     </div>
    //             //     <div className="skeleton-listing-card">
    //             //         <Skeleton className="thumbnail-image"/>
    //             //         <Skeleton count={3} width="50%"/>
    //             //     </div>
    //             //     <div className="skeleton-listing-card">
    //             //         <Skeleton className="thumbnail-image"/>
    //             //         <Skeleton count={3} width="50%"/>
    //             //     </div>
    //             // </div>
    //             // :
    //                 listings && listings.length > 0 ? 
    //                 <div className={className ? `${className} listings-grid` : "listings-grid"}>
    //                     {listings.map((listing, i) => (
    //                         <ListingCard key={`listing-card-${i}`} listing={listing}></ListingCard>
    //                     )) }
    //                 </div>: 
    //                     listings && listings.length == 0 ?
    //                     <div>
    //                         No Listings Found
    //                     </div>
    //                     : <></>
    //             }
    // </div>
    <div className="list-listings-container">
        <div className="list-listings">
            {listings && listings.length > 0 ? 
            <div className={className ? `${className} listings-grid` : "listings-grid"}>
                {listings.map((listing, i) => (
                    <ListingCard key={`listing-card-${i}`} listing={listing} listings={listings} setListings={setListings}></ListingCard>
                )) }
            </div>: 
                listings && listings.length == 0 ?
                <div>
                    No Listings Found
                </div>
                : <></>
            }
        </div>
        <div ref={containerRef} className="intersection"></div>
        {useListingsContext().listings==null && <ListingsSkeleton className={className}/>}
    </div>
)}
export default ListListings